import { Link } from 'react-router-dom'

import { OrgPermission } from '@makyoapp/makyo-sdk/models/ACL'

import { useCurrentOrgContext } from '@/context/CurrentOrgContext'
import { useOrgPerm } from '@/hooks/useOrgPerm'
import { ORG_BRAND_KIT_ROUTE, ORG_ROUTE } from '@/shared/constants'

import { ReactComponent as IconDatabase } from '@/assets/vectors/icon_lucide_database.svg?react'
import { ReactComponent as IconNetwork } from '@/assets/vectors/icon_lucide_network.svg?react'
import { ReactComponent as IconPalette } from '@/assets/vectors/icon_lucide_palette.svg?react'
import { ReactComponent as IconUpload } from '@/assets/vectors/icon_lucide_upload.svg?react'

export default function ManagementSection() {
  const { currentOrg } = useCurrentOrgContext()
  const canAccessBrandKit = useOrgPerm(OrgPermission.BrandKitAccess)

  if (!currentOrg) return null

  return (
    <>
      <div className='bg-white dark:bg-slate-800/50 rounded-xl p-6 backdrop-blur-xs border border-slate-200/50 dark:border-slate-700/50 shadow-xs mb-8'>
        <h2 className='text-lg font-medium text-slate-900 dark:text-white mb-6'>Management</h2>
        <div className='grid grid-cols-2 gap-4'>
          {canAccessBrandKit && (
            <Link
              to={`${ORG_ROUTE}/${currentOrg.id}/${ORG_BRAND_KIT_ROUTE}`}
              className='flex items-center p-4 bg-slate-100 dark:bg-slate-700/30 rounded-lg hover:bg-slate-200 dark:hover:bg-slate-700/50 transition-all'
            >
              <span className='p-2 rounded-lg bg-slate-200 dark:bg-slate-600/50 text-slate-600 dark:text-slate-300'>
                <IconPalette className='h-5 w-5 fill-transparent' />
              </span>
              <div className='text-left ml-4'>
                <div className='font-medium text-slate-900 dark:text-white'>Brand Settings</div>
                <div className='text-sm text-slate-600 dark:text-slate-400'>Customize your brand identity</div>
              </div>
            </Link>
          )}

          <Link
            to={`${ORG_ROUTE}/${currentOrg.id}/db`}
            className='flex items-center p-4 bg-slate-100 dark:bg-slate-700/30 rounded-lg hover:bg-slate-200 dark:hover:bg-slate-700/50 transition-all'
          >
            <span className='p-2 rounded-lg bg-slate-200 dark:bg-slate-600/50 text-slate-600 dark:text-slate-300'>
              <IconDatabase className='h-5 w-5 fill-transparent' />
            </span>
            <div className='text-left ml-4'>
              <div className='font-medium text-slate-900 dark:text-white'>Databases</div>
              <div className='text-sm text-slate-600 dark:text-slate-400'>Manage your data sources</div>
            </div>
          </Link>

          <button className='flex items-center p-4 bg-slate-100 dark:bg-slate-700/30 rounded-lg hover:bg-slate-200 dark:hover:bg-slate-700/50 transition-all'>
            <span className='p-2 rounded-lg bg-slate-200 dark:bg-slate-600/50 text-slate-600 dark:text-slate-300'>
              <IconNetwork className='h-5 w-5 fill-transparent' />
            </span>
            <div className='text-left ml-4'>
              <div className='font-medium text-slate-900 dark:text-white'>API Access</div>
              <div className='text-sm text-slate-600 dark:text-slate-400'>Configure API endpoints</div>
            </div>
          </button>

          <button className='flex items-center p-4 bg-slate-100 dark:bg-slate-700/30 rounded-lg hover:bg-slate-200 dark:hover:bg-slate-700/50 transition-all'>
            <span className='p-2 rounded-lg bg-slate-200 dark:bg-slate-600/50 text-slate-600 dark:text-slate-300'>
              <IconUpload className='h-5 w-5 fill-transparent' />
            </span>
            <div className='text-left ml-4'>
              <div className='font-medium text-slate-900 dark:text-white'>Upgrade Plan</div>
              <div className='text-sm text-slate-600 dark:text-slate-400'>Explore premium features</div>
            </div>
          </button>
        </div>
      </div>
    </>
  )
}
